
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import _export from '../internals/export.js';
import globalThis_1 from '../internals/global-this.js';
import schedulersFix$1 from '../internals/schedulers-fix.js';

var $ = _export;
var globalThis = globalThis_1;
var schedulersFix = schedulersFix$1;

var setInterval = schedulersFix(globalThis.setInterval, true);

// Bun / IE9- setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
$({ global: true, bind: true, forced: globalThis.setInterval !== setInterval }, {
  setInterval: setInterval
});
//# sourceMappingURL=web.set-interval.js.map
